import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
  mutation EmotionEpisodeSetRecordingStatus($uid: String!, $status: String!){
              emotion_episode_set_recording_status (uid: $uid, status: $status) {
                  success
              }
          }
`;

export async function emotionEpisodeSetRecordingStatus(uid: string, status: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ emotion_episode_set_recording_status: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid, status },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.emotion_episode_set_recording_status;
}
